import pixAxios from '@/axios/pixAxios.js';
import jllLocalstorageManager from 'jll-localstorage-manager';
import Console from '@/shared/console';

const mapModule = {
  namespaced: true,
  state: {
    layersCountries: [], // Listado con los paises de las capas de la aplicación.
    configByCountry: '',
    layer: '',
    map: null,
    infowindow: {
      content: '',
      location: null,
    },
    markersInfo: {
      collection: [],
      reloaded: false,
      adjust: false,
      cluster: false,
    },
    mapMarkers: null,
    activeMarker: null,
    selectedMarkerInfo: {
      id: null,
      typeInfo: null,
    },
    mapCenter: null,
    isAoiMode: false,
    modalObj: {
      data: null,
      content: null,
      header: null,
      contentClass: null,
      modalClass: null,
    },
    auditObj: {
      rowId: null,
    },
    country: null,
    showStreetView: null,
  },
  actions: {
    getCountriesList({ state, commit, rootState }) {
      const storedlist = jllLocalstorageManager.get('LazLayersCountriesList');
      if (storedlist != null) {
        /* Se cargan desde la localstorage */
        commit('setLayersCountriesList', storedlist);
      } else {
        /* Se cargan desde la base de datos */
        pixAxios
          .get(`api/MapLayers/GetCountriesLayers?culture=${rootState.langCode}`)
          .then((response) => {
            const countriesList = response.data;
            jllLocalstorageManager.set('LazLayersCountriesList', countriesList, 1000 * 3600);
            commit('setLayersCountriesList', countriesList);
          })
          .catch((error) => {
            const countriesList = [];
            Console.log(error);
            commit('setLayersCountriesList', countriesList);
          });
      }
    },

    getLayersByCountry({ state, commit, rootState }, country) {
      const key = `LazLayerByCountry_${country}`;
      const storedlist = jllLocalstorageManager.get(key);
      if (storedlist != null) {
        /* Se cargan desde la localstorage */
        commit('setLayersConfigByCountry', storedlist);
      } else {
        /* Se cargan desde la base de datos */
        return pixAxios
          .get(`api/MapLayers/GetLayersConfigByCountry?country=${country}&culture=${rootState.langCode}`)
          .then((response) => {
            const configByCountry = response.data;
            jllLocalstorageManager.set(key, configByCountry, 1000 * 3600);
            commit('setLayersConfigByCountry', configByCountry);
          })
          .catch((error) => {
            const configByCountry = [];
            Console.log(error);
            commit('setLayersConfigByCountry', configByCountry);
          });
      }
    },

    /**
     * Elementos del mapa
     * @param {any} param0
     * @param {any} layer
     */
    loadLayer({ state, commit }, layer) {
      commit('setLoadLayer', layer);
    },
    setMap({ state, commit }, map) {
      commit('setMap', map);
    },
    setInfowindow({ state, commit }, data) {
      commit('setInfowindow', data);
    },
    setMarkersCollection({ state, commit }, payload) {
      commit('setMarkersCollection', payload);
    },
    setActiveMarker({ state, commit }, payload) {
      commit('setActiveMarker', payload);
    },
    setMapMarkersCollection({ state, commit }, mapMarkers) {
      commit('setMapMarkersCollection', mapMarkers);
    },
    setSelectedMarkerInfo({ state, commit }, markerInfo) {
      commit('setSelectedMarkerInfo', markerInfo);
    },
    setMapCenter({ state, commit }, center) {
      commit('setMapCenter', center);
    },
    setIsAoiModeFlag({ state, commit }, isAoiMode) {
      commit('setIsAoiModeFlag', isAoiMode);
    },
    setFullScreenModal({ state, commit }, modalObj) {
      commit('setFullScreenModal', modalObj);
    },
    setFullScreenAuditModal({ state, commit }, auditObj) {
      commit('setFullScreenAuditModal', auditObj);
    },
    setMapCountry({ state, commit }, country) {
      commit('setMapCountry', country);
    },
    setShowStreetView({ state, commit }, showStreetView) {
      commit('setShowStreetView', showStreetView);
    },
  },
  mutations: {
    /**
     * @param {any} state
     * @param {any} clientList
     */
    setLayersCountriesList(state, layersCountries) {
      state.layersCountries = layersCountries;
    },
    setLayersConfigByCountry(state, configByCountry) {
      state.configByCountry = configByCountry;
    },
    setLoadLayer(state, layer) {
      state.layer = layer;
    },
    setMap(state, map) {
      state.map = map;
    },
    setInfowindow(state, data) {
      const infowindow = { content: data.infowindowTemplate, location: data.latLng, marker: data.marker };
      state.infowindow = infowindow;
    },
    setMarkersCollection(state, markersInfo) {
      state.markersInfo = markersInfo;
    },
    setActiveMarker(state, marker) {
      state.activeMarker = marker;
    },
    setMapMarkersCollection(state, mapMarkers) {
      state.mapMarkers = null;
      state.mapMarkers = mapMarkers;
    },
    setSelectedMarkerInfo(state, markerInfo) {
      state.selectedMarkerInfo = null;
      state.selectedMarkerInfo = markerInfo;
    },
    setMapCenter(state, center) {
      state.mapCenter = center;
    },
    setIsAoiModeFlag(state, isAoiMode) {
      state.isAoiMode = false;
      state.isAoiMode = isAoiMode;
    },
    setFullScreenModal(state, modalObj) {
      state.modalObj = modalObj;
    },
    setFullScreenAuditModal(state, auditObj) {
      state.auditObj = auditObj;
    },
    setMapCountry(state, country) {
      state.country = country;
    },
    setShowStreetView(state, showStreetView) {
      state.showStreetView = showStreetView;
    },
  },
  getters: {
    /**
     * Devuelve las listas y configuraciones
     * @param {any} state
     */
    getCountriesList(state) {
      try {
        return state.layersCountries;
      } catch (err) {
        return [];
      }
    },

    getLayersConfigByCountry(state) {
      try {
        return state.configByCountry;
      } catch (err) {
        return [];
      }
    },

    getLoadLayer(state) {
      try {
        return state.layer;
      } catch (err) {
        return null;
      }
    },

    /**
     * Devuelve elementos del mapa
     * @param {any} state
     */
    getMap(state) {
      try {
        return state.map;
      } catch (err) {
        return null;
      }
    },
    getInfowindow(state) {
      try {
        return state.infowindow;
      } catch (err) {
        return null;
      }
    },
    getMarkersCollection(state) {
      try {
        return state.markersInfo;
      } catch (err) {
        return null;
      }
    },
    GetMapMarkersCollection(state) {
      try {
        return state.mapMarkers;
      } catch (err) {
        return null;
      }
    },
    getActiveMarker(state) {
      try {
        return state.activeMarker;
      } catch (err) {
        return null;
      }
    },
    getSelectedMarkerInfo(state) {
      try {
        return state.selectedMarkerInfo;
      } catch (err) {
        return null;
      }
    },
    getMapCenter(state) {
      try {
        return state.mapCenter;
      } catch (err) {
        return null;
      }
    },
    getIsAoiModeFlag(state) {
      try {
        return state.isAoiMode;
      } catch (err) {
        return null;
      }
    },

    getFullScreenModal(state) {
      try {
        return state.modalObj;
      } catch (err) {
        return null;
      }
    },
    getFullScreenAuditModal(state) {
      try {
        return state.auditObj;
      } catch (err) {
        return null;
      }
    },
    getMapCountry(state) {
      try {
        return state.country;
      } catch (err) {
        return null;
      }
    },
    getShowStreetView(state) {
      try {
        return state.showStreetView;
      } catch (err) {
        return null;
      }
    },
  },
};
export default mapModule;
